<template>
  <v-card class="mx-auto text-center mt-2 mb-2" color="#f1f1f1">
    <v-card-text>
      <h1>Turnover / Month</h1>
      <!-- <h2>{{ getData() }}</h2> -->
      <!-- <button @click="createChart">Create Chart</button> -->
    </v-card-text>

    <v-card-text>
      <canvas ref="myChart" width="100" height="40"></canvas>
    </v-card-text>
    <!-- 
    <v-divider></v-divider>

    <v-card-actions class="justify-center">
      <v-btn block text>Go to Report</v-btn>
    </v-card-actions>-->
  </v-card>
</template>

<script>
import Chart from "chart.js";
import moment from "moment";

export default {
  methods: {
    createChart() {
      doCreateChart();
    },
    getData() {
      let result = this.$store.getters.getDashboardInfo("turnover_month");
      return result;
    }
  },
  mounted() {
    let el = this.$refs.myChart;
    doCreateChart(el);
  }
};

const lastTwelveMonths = () => {
  const arr = [];
  // create a current start date of the 1st of this month
  const fistOfThisMonth = moment().set("date", 1);
  const startMonth = fistOfThisMonth.subtract(12, "months");
  for (let i = 0; i < 12; i++)
    arr.push(startMonth.add(1, "months").format("MMM"));
  return arr;
};

const getRandomTurnover = () => {
  return Math.floor(Math.random() * Math.floor(5000));
};

const getRandomTurnoverArr = () => {
  const arr = [];
  for (let i = 0; i < 12; i++) arr.push(getRandomTurnover());
  return arr;
};

const doCreateChart = el => {
  //var ctx = document.getElementById("myChart");
  var myChart = new Chart(el, {
    type: "bar",
    data: {
      labels: lastTwelveMonths(),
      datasets: [
        {
          data: getRandomTurnoverArr(),
          backgroundColor: "rgba(54, 162, 235, 1)",
          borderColor: "rgba(153, 102, 255, 1)",
          borderWidth: 1,
          fill: false
        }
      ]
    },
    options: {
      legend: false,
      scales: {
        yAxes: [
          {
            ticks: {
              beginAtZero: true
            }
          }
        ]
      }
    }
  });
};
</script>

<style>
</style>